import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c3461464")

_pushScopeId("data-v-c3461464")
const _hoisted_1 = { class: "multi-view-center-list-item-root" }
const _hoisted_2 = { class: "header" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_road_map_view = _resolveComponent("road-map-view")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("span", null, _toDisplayString(_ctx.title), 1),
      _createVNode("span", null, _toDisplayString(_ctx.xueAndJu), 1),
      _createVNode("span", {
        class: [_ctx.timerClass, "timer"]
      }, _toDisplayString(_ctx.currentTime !== -1 ? _ctx.currentTime : ''), 3)
    ]),
    _createVNode(_component_road_map_view, {
      class: "map",
      display: 3,
      mapData: _ctx.deskResult
    }, null, 8, ["mapData"])
  ]))
})